module.exports = __webpack_public_path__ + "static/media/ucc.69e46172.png";